export default __webpack_public_path__ + "static/drawer.light-53b117f4c3640d23f7bb757ef0d44589b10b3b785db0f974d1dda594e0f1768d.png";